<template>
  <div id="nav-bar">
    <div class="desktop-nav">
      <div class="brand">
        <!-- <img class="brand-logo" src="../assets/256 amcenter.png" alt="logo" width="56px"> -->
        <span class="brand-name">AM Center X</span>
      </div>

      <!-- Nav links to projects, inventory and users -->
      <div class="nav-wrapper">
        <div class="nav-link" @click="navTo('PROJECTS')">
          <span class="link-text" :style="currentPage === 'PROJECTS' ? 'color: #409eff' : ''">Projects</span>
        </div>
        <div class="nav-link" @click="navTo('INVENTORY')">
          <span class="link-text" :style="currentPage === 'INVENTORY' ? 'color: #409eff' : ''">Inventory</span>
        </div>
        <div class="nav-link" @click="navTo('USERS')">
          <span class="link-text" :style="currentPage === 'USERS' ? 'color: #409eff' : ''">Users</span>
        </div>
      </div>

      <!-- Log out -->
      <div class="me">
        <div class="me-wrapper">
          <el-button round @click="signOut()">Log Out</el-button>
        </div>
      </div>

    </div>

    <!-- mobile nav  -->
    <div class="mobile-nav">
      <div class="brand">
        <!-- <img class="brand-logo" src="../assets/256 amcenter.png" alt="logo" width="56px"> -->
        <span class="brand-name">AM Center X</span>
      </div>
      <div class="bread-nav" @click="mobileNavVisible = !mobileNavVisible">
        <transition name="menu-animate">
          <img src="../assets/menu (2).svg" alt="menu icon" width="32px" v-if="!mobileNavVisible">
        </transition>
        <transition name="close-animate">
          <img src="../assets/close.svg" alt="close icon" width="32px" v-if="mobileNavVisible">
        </transition>
      </div>

      <!-- Mobile dark mask -->
      <div class="nav-list-w" v-if="mobileNavVisible" @click="mobileNavVisible = false"></div>

      <!-- Mobile list -->
      <div class="nav-list" v-if="mobileNavVisible">
        <div style="height: 280px; overflow-y: auto">
          <div class="mobile-link" @click="navTo('PROJECTS'), mobileNavVisible = false" :style="currentPage === 'PROJECTS' ? 'color: #409eff':''">
            <span class="mobile-text">Projects</span>
          </div>
          <div class="mobile-link" @click="navTo('INVENTORY'), mobileNavVisible = false" :style="currentPage === 'INVENTORY' ? 'color: #409eff':''">
            <span class="mobile-text">Inventory</span>
          </div>
          <div class="mobile-link" v-if="canViewUsers" @click="navTo('USERS'), mobileNavVisible = false" :style="currentPage === 'USERS' ? 'color: #409eff':''">
            <span class="mobile-text">Users</span>
          </div>
          <div class="mobile-link">
            <el-button round style="margin-top: 20px" @click="signOut()">Log Out</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
  props: ['currentPage'],
  data () {
    return {
      // accountVisible: false,

      mobileNavVisible: false
    }
  },
  computed: {
    canViewUsers: function () {
      // eslint-disable-next-line no-mixed-operators
      return this.$store.getters.currentUserInfo && this.$store.getters.currentUserInfo.permits.USER_VIEW || false
    }
  },
  methods: {
    signOut: function () {
      // console.log('signOut')
      this.$store.dispatch('signOutUser')
    },
    navTo: function (targetPage) {
      switch (targetPage) {
        case 'PROJECTS':
          this.$router.push('/')
          break
        case 'INVENTORY':
          this.$router.push('/inventory')
          break
        case 'USERS':
          this.$router.push('/users')
          break
        default:
          break
      }
    }
  }
}
</script>

<style scoped>
#nav-bar {
  width: 100%;
  height: 80px;
  background-color: #faf9fa;
}
.desktop-nav {
  width: 80%;
  height: 80px;
  margin: auto;
  display: flex;
  justify-content: space-between;
}
.brand {
  box-sizing: border-box;
  padding: 4px 12px 0 12px;
  display: flex;
  align-items: center;
  width: 220px;
}
.brand-name {
  font-size: 24px;
  font-family: 'Audiowide', cursive;
  color: rgba(0, 0, 0, 0.95)
}
.nav-wrapper {
  display: flex;
  width: calc(100% - 440px);
  box-sizing: border-box;
  padding-left: calc((100% - 440px - 360px) / 2)
}
.nav-link {
  display: inline-block;
  width: 120px;
  text-align: center;
  cursor: pointer;
  position: relative;
}
.link-text {
  font-size: 16px;
  font-weight: 600;
  line-height: 80px;
  cursor: pointer;
}
.me {
  width: 220px;
  height: 80px;
  box-sizing: border-box;
  padding: 24px 12px 16px 0;
  position: relative;
}
.me-wrapper {
  text-align: right;
  cursor: pointer;
}
.me-icon {
  margin-left: auto;
  margin-right: auto;
  display: block
}
.select-line {
  width: 50px;
  height: 2.5px;
  background-color: #409eff;
  position: absolute;
  bottom: 0;
  left: 50px;
  animation: lineExpand 0.3s ease;
}
.logout-wrapper {
  position: fixed;
  right: 5%;
  top: 85px;
  z-index: 10;
  width: 150px;
  box-sizing: border-box;
  padding: 20px 0;
  background-color: #fafafa;
  border: solid 1px #ccc;
  border-radius: 10px;
  text-align: center
}
.mobile-nav {
  display: none;
}

@media screen and (max-width: 991px) {
  .menu-animate-enter-active {
    transition: all .1s ease;
  }
  .menu-animate-leave-active {
    transition: all .1s ease;
  }
  .menu-animate-enter, .menu-animate-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(-10px);
    opacity: 0;
  }
  .menu-animate-leave, .menu-animate-enter-to {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }

  .close-animate-enter-active {
    transition: all .1s ease;
  }
  .close-animate-leave-active {
    transition: all .1s ease;
  }
  .close-animate-enter, .close-animate-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }

  .desktop-nav {
    display: none
  }
  .mobile-nav {
    display: flex;
    justify-content: space-between;
    height: 80px;
  }
  .brand {
    padding: 4px 12px 0 24px;
    font-size: 16px;
  }
  .bread-nav {
    width: 48px;
    height: 48px;
    box-sizing: border-box;
    padding: 8px;
    margin-right: 16px;
    margin-top: 16px;
    display: flex;
  }
  .nav-list-w {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    left: 0;
    right: 0;
    top: 80px;
    bottom: 0;
    z-index: 9;
  }
  .nav-list {
    width: 60%;
    height: calc(100vh - 80px);
    position: fixed;
    top: 80px;
    right: 0;
    z-index: 10;
    border-bottom: solid 1px #ccc;
    box-sizing: border-box;
    padding: 0 0 20px 0;
    animation: toggleNav 0.3s ease;
    background-color: #ffffff;
  }
  .mobile-link {
    height: 60px;
    box-sizing: border-box;
    padding: 0 16px;
    text-align: center;
    cursor: pointer;
  }
  .mobile-text {
    font-size: 16px;
    font-weight: bold;
    line-height: 60px;
  }
}

@keyframes lineExpand {
  from {
    width: 0;
  }
  to {
    width: 50px;
  }
}

@keyframes toggleNav {
  from {
    max-width: 0;
    overflow: hidden;
  }
  to {
    max-width: 60%;
    overflow: hidden;
  }
}
</style>
